import React from "react";
import { Layers } from "lucide-react";

/**
 * ============================================================
 * WORKSHOP AGENDA
 * ============================================================
 * Technical curriculum timeline presenting workshop modules.
 * Renders null if agenda is empty.
 */
export default function WorkshopAgenda({ agenda = [] }) {
  if (!agenda || !Array.isArray(agenda) || agenda.length === 0) {
    return null;
  }

  return (
    <section aria-labelledby="curriculum-agenda-heading" className="w-full">
      <div className="rounded-3xl border border-white/10 bg-white/[0.03] p-6 sm:p-8 backdrop-blur-xl shadow-[0_18px_50px_rgba(0,0,0,0.35)]">
        {/* Section Header */}
        <div className="flex items-center gap-2.5 mb-8">
          <div className="w-8 h-8 rounded-xl bg-primary/15 border border-primary/25 text-primary flex items-center justify-center flex-shrink-0">
            <Layers className="w-4 h-4" />
          </div>
          <div>
            <h2 id="curriculum-agenda-heading" className="text-xl sm:text-2xl font-bold tracking-tight text-white">
              Workshop Curriculum & Agenda
            </h2>
            <p className="text-xs sm:text-sm text-white/60">
              Module-by-module breakdown of topics, labs, and interactive sessions.
            </p>
          </div>
        </div>

        {/* Timeline Container */}
        <div className="relative pl-6 sm:pl-8 ml-2 sm:ml-4 border-l border-primary/30 space-y-8">
          {agenda.map((item, idx) => (
            <div key={idx} className="relative group">
              {/* Timeline Glowing Node */}
              <div
                aria-hidden="true"
                className="absolute -left-[31px] sm:-left-[39px] top-1 w-3.5 h-3.5 sm:w-4 sm:h-4 rounded-full bg-background border-2 border-primary shadow-[0_0_12px_rgba(0,194,255,0.7)] group-hover:scale-125 transition-transform duration-300"
              />

              {/* Module Content Box */}
              <div className="space-y-2 p-4 sm:p-5 rounded-2xl border border-white/5 bg-white/[0.02] group-hover:bg-white/[0.04] group-hover:border-primary/20 transition-all duration-300">

                {/* Topic Title */}
                <h3 className="text-base sm:text-lg font-bold text-white tracking-tight">
                  {item.topic}
                </h3>

                {/* Description */}
                {item.description && (
                  <p className="text-xs sm:text-sm text-white/70 leading-relaxed font-normal">
                    {item.description}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
